import React, { useState } from "react";
import Switch from "@mui/material/Switch";
import { useDispatch, useSelector } from "react-redux"; // Import Redux hooks
//import makeStyles from '@mui/style/makeStyles';
//import Switch from "@mui/material/Switch";
import { styled } from "@mui/system";
//import { updateFetchHistoricalAlerts, updatePreviousFetchHistoricalAlerts } from "../../../../store/alarm_data"; // Import Redux action

export default function SwitchComponent({checkedA, energyconsumersaver, setStateVarConsumerSaver, switchstate}){

    //const[energyconsumersaver, setStateVarConsumerSaver] = useState(true)
    const[selectedVal, setSelectedValue] = useState("Realtime")
    const dispatch = useDispatch();
    const fetchHistoricalAlerts = useSelector((state) => state.alarmdata.fetchHistoricalAlerts); // Redux state

    const MaterialUISwitch = styled(Switch)(({ theme }) => ({
        width: "84px",
        height: "28px",
        padding: "0px",
        justifyContent:"center",
        '& .MuiSwitch-switchBase': {
              color: "#B5BFBC",
              padding: "0px",
              justifyContent:"center",
              '&.Mui-checked + .MuiSwitch-track': {
                  backgroundColor: "#005C8E",      
              },
         },
        '& .MuiSwitch-thumb': {
              color: "#E0E0E0",
              width: "20px",
              height: "20px",
              margin: "4px 5px 4px 5px",
              padding:"0px"
        },
        '& .MuiSwitch-track': {
              borderRadius: "20px",
              backgroundColor:"#005C8E",
              justifyContent:"center",
              opacity: "1 !important",
              '&:after': {
                color: "#E0E0E0",
                fontSize: "11px",
                position: "relative",
                marginLeft:"25px",
                marginTop:"10px",
                paddingTop:"10px",
                content:(energyconsumersaver==false)?'"Historical"':'""'
            },
      
        },
        '& .Mui-checked': {
            color: "#005C8E",
            transform: "translateX(10px) !important",
            transitionDuration: '4s',
            transitionDelay:'10s',
            '&: before': {
              color: "#E0E0E0",
              fontSize: "11px",
              position: "relative",
              marginBottom:"2px",
              content:'"Realtime"'
          },
           
        },
      }));

    function handleChangeEnergyCostBudget(event){
        switchstate = !switchstate;
        setStateVarConsumerSaver(!energyconsumersaver);
        if(energyconsumersaver == false){
            setSelectedValue("Realtime")
            //dispatch(updateFetchHistoricalAlerts(false));
        }else{
            setSelectedValue("Historical")
            //dispatch(updateFetchHistoricalAlerts(true));
        }
       
    };

    return(<>
        <div style={{borderRadius:"20px"}}>
            <div style={{display: 'flex', marginRight: '20px', marginTop: '20px'}}>
                <div style={{flexGrow: 1}}></div>
                <MaterialUISwitch
                    checked={energyconsumersaver}
                    onChange={handleChangeEnergyCostBudget}
                    name="Name"
                    inputProps={{ "aria-label": "secondary checkbox" }}
                />
            </div>
            
                                      
        </div>
    </>)
}